import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';

import { notFoundRootSx } from './NotFound.styles';

function NotFound() {
  return (
    <Stack spacing={2} sx={notFoundRootSx}>
      <Typography variant="h3" component="h1" color="primary">
        Lost in the Mist
      </Typography>
      <Typography>The path you seek does not exist on these tarot tables.</Typography>
      <Button variant="contained" component={RouterLink} to="/">
        Return Home
      </Button>
    </Stack>
  );
}

export default NotFound;
